"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const CaretDownCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-638.000000, -344.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(638.000000, 344.000000)",
        fill: color,
        fillRule: "nonzero",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M11.5,0 C5.14872538,0 0,5.14872538 0,11.5 C0,17.8512746 5.14872538,23 11.5,23 C17.8512746,23 23,17.8512746 23,11.5 C23,5.14872538 17.8512746,0 11.5,0 Z M11.5,2 C16.7467051,2 21,6.25329488 21,11.5 C21,16.7467051 16.7467051,21 11.5,21 C6.25329488,21 2,16.7467051 2,11.5 C2,6.25329488 6.25329488,2 11.5,2 Z"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M15.584657,9.22291433 C15.9304439,8.90448014 16.4655919,8.93029434 16.7799436,9.28057194 C17.0701143,9.60390512 17.0707216,10.0906829 16.7971274,10.4141157 L16.7230252,10.4913817 L12.0691841,14.7770917 C11.7733384,15.0495352 11.3345229,15.0722388 11.0148489,14.8452026 L10.9308159,14.7770917 L6.27697484,10.4913817 C5.931188,10.1729476 5.90570476,9.63084955 6.22005644,9.28057194 C6.51022721,8.95723877 6.98853214,8.91037146 7.33237124,9.15553143 L7.41534295,9.22291433 L11.5,12.9848592 L15.584657,9.22291433 Z",
          transform: "translate(11.500000, 12.000000) rotate(-360.000000) translate(-11.500000, -12.000000)"
        })]
      })
    })
  })]
});

CaretDownCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = CaretDownCircleIcon;
exports.default = _default;